module.exports = __webpack_public_path__ + "img/kalunga.890f8ab7.jpg";